var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDebug = function SvgIconDebug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Debug",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Custom-Preset",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#979797",
    cx: 16,
    cy: 16,
    rx: 6.5,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#979797",
    cx: 16,
    cy: 6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "21.1520171 9.81193367 24.9430692 6.28140569 29.1520171 11.0264231"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "22.5824936 16.7294549 26.916542 13.5506859 29.7595341 18.8177862"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "20.3544573 22.741499 25.1710138 21.1072124 27.3564555 27.5235037"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(-1 0 0 1 13.52 0)",
    points: "2.7595341 9.81193367 6.55058626 6.28140569 10.7595341 11.0264231"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(-1 0 0 1 11.481 0)",
    points: "2.15201707 16.7294549 6.48606552 13.5506859 9.32905762 18.8177862"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(-1 0 0 1 16.112 0)",
    points: "4.55509562 22.741499 9.3716521 21.1072124 11.5570938 27.5235037"
  })))));
};
export { SvgIconDebug as ReactComponent };
export default "data:image/svg+xml;base64,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";